import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { LiveMiniPlayer } from '../../contexts/LiveSessionContext';
import useDataTracker from '../../hooks/useDataTracker';
import { stripLocalePrefix } from '../../utils/localePaths';

export function Layout() {
  const location = useLocation();
  useDataTracker();
  const logicalPathname = stripLocalePrefix(location.pathname);
  const isLiveRoom = /^\/live\/chat\/[^/]+(\/call)?$/.test(logicalPathname) || /^\/live\/voice\/[^/]+$/.test(logicalPathname);

  const isCharacterChat = /^\/character-chat\/[^/]+$/.test(logicalPathname);

  useEffect(() => {
    document.body.classList.toggle('live-room-active', isLiveRoom);
    return () => document.body.classList.remove('live-room-active');
  }, [isLiveRoom]);

  useEffect(() => {
    document.body.classList.toggle('character-chat-active', isCharacterChat);
    return () => document.body.classList.remove('character-chat-active');
  }, [isCharacterChat]);

  return (
    <>
      <div className={`app-content${isLiveRoom ? ' live-room-app' : ''}${isCharacterChat ? ' character-chat-app' : ''}`}>
        <Header />
        <main style={{ minHeight: 'calc(100vh - 140px)', paddingTop: 'var(--header-height, 52px)' }}>
          <Outlet />
        </main>
        {!isLiveRoom && !isCharacterChat && <Footer />}
      </div>
      <LiveMiniPlayer />
    </>
  );
}
